/* src/app/talk-ai-agent/talk-ai-agent.component.scss */
.voice-agent {
  width: 100%;
  padding: 6px;
  display: flex;
  justify-content: center;
  background: #f4f6fa;
}
.agent-card {
  width: 100%;
  max-width: 920px;
  min-height: 623px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px;
  position: relative;
  overflow: hidden;
}
.agent-method {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  padding: 22px;
  margin-bottom: 30px;
  background: #f8faff;
  border: 1px solid #e3e8f5;
  border-radius: 18px;
}
.agent-select {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.agent-select label {
  font-size: 15px;
  line-height: 1.4;
  font-weight: 600;
  color: #253b80;
}
.agent-select select {
  width: 100%;
  min-height: 48px;
  padding: 0 42px 0 14px;
  appearance: none;
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  background-color: #ffffff;
  background-image:
    linear-gradient(
      45deg,
      transparent 50%,
      #64748b 50%),
    linear-gradient(
      135deg,
      #64748b 50%,
      transparent 50%);
  background-position: calc(100% - 18px) 20px, calc(100% - 13px) 20px;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  border: 1px solid #d7dce5;
  border-radius: 10px;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
  cursor: pointer;
}
.agent-select select:hover:not(:disabled) {
  border-color: #9aa8cc;
}
.agent-select select:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.agent-select select:disabled {
  color: #9ca3af;
  background-color: #f3f4f6;
  cursor: not-allowed;
}
.avatar-ring {
  width: 210px;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 6px 0 20px;
}
.agent-avatar {
  width: 152px;
  height: 152px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 4;
  overflow: hidden;
  border-radius: 50%;
  border: 5px solid #ffffff;
  background: #eef2ff;
  box-shadow: 0 12px 35px rgba(37, 59, 128, 0.18), 0 0 0 1px rgba(37, 59, 128, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.agent-avatar__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.agent-avatar--speaking {
  transform: scale(1.04);
  box-shadow: 0 15px 40px rgba(37, 59, 128, 0.24), 0 0 0 5px rgba(37, 59, 128, 0.08);
}
.pulse {
  position: absolute;
  width: 172px;
  height: 172px;
  border-radius: 50%;
  border: 2px solid rgba(37, 59, 128, 0.16);
  opacity: 0;
  transform: scale(0.85);
  pointer-events: none;
}
.pulse.active {
  animation: voicePulse 2.2s ease-out infinite;
}
.pulse2.active {
  animation-delay: 0.8s;
}
@keyframes voicePulse {
  0% {
    opacity: 0.5;
    transform: scale(0.85);
  }
  70% {
    opacity: 0;
    transform: scale(1.25);
  }
  100% {
    opacity: 0;
    transform: scale(1.3);
  }
}
.status-dot {
  position: absolute;
  z-index: 5;
  right: 22px;
  bottom: 25px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.15);
}
.status-dot.connected {
  background: #22c55e;
}
.status-dot.disconnected {
  background: #94a3b8;
}
.agent-info {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}
.agent-info p {
  margin: 0 0 7px;
  font-size: 17px;
  line-height: 1.5;
  font-weight: 600;
  color: #253b80;
}
.agent-info span {
  display: inline-block;
  max-width: 90%;
  padding: 6px 14px;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  border-radius: 999px;
}
.ai-body {
  width: 100%;
  height: 195px;
  padding: 20px;
  overflow-y: auto;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  scroll-behavior: smooth;
}
.ai-body::-webkit-scrollbar {
  width: 7px;
}
.ai-body::-webkit-scrollbar-track {
  background: transparent;
}
.ai-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.transcript-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
}
.transcript-item:last-child {
  margin-bottom: 0;
}
.transcript-item .transcript-role {
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 700;
  color: #64748b;
}
.transcript-item .transcript-container {
  max-width: 78%;
}
.transcript-item .transcript-text {
  padding: 12px 16px;
  font-size: 15px;
  line-height: 1.6;
  color: #1f2937;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03);
  word-break: break-word;
}
.transcript-item.agent {
  align-items: flex-start;
}
.transcript-item.agent .transcript-role {
  color: #253b80;
}
.transcript-item.agent .transcript-text {
  border-top-left-radius: 5px;
}
.transcript-item.user {
  align-items: flex-end;
}
.transcript-item.user .transcript-role {
  text-align: right;
  color: #64748b;
}
.transcript-item.user .transcript-container {
  display: flex;
  justify-content: flex-end;
}
.transcript-item.user .transcript-text {
  border-top-right-radius: 5px;
  background: #253b80;
  color: #ffffff;
  border-color: #253b80;
}
.empty-state {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 30px;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 500;
  color: #64748b;
}
.chat-input {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
.chat-input input {
  flex: 1;
  min-width: 0;
  height: 50px;
  padding: 0 16px;
  font-size: 15px;
  line-height: 1.4;
  color: #111827;
  background: #ffffff;
  border: 1px solid #d7dce5;
  border-radius: 12px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.chat-input input::placeholder {
  color: #9ca3af;
}
.chat-input input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.09);
}
.send-btn {
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 12px;
  color: #ffffff;
  background: #253b80;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.send-btn i {
  font-size: 17px;
}
.send-btn:hover {
  background: #344f91;
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(37, 59, 128, 0.2);
}
.send-btn:active {
  transform: translateY(0);
}
.connect-btn {
  width: 100%;
  max-width: 380px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 22px;
  border: 0;
  border-radius: 13px;
  font-size: 16px;
  line-height: 1;
  font-weight: 700;
  color: #ffffff;
  background: #253b80;
  cursor: pointer;
  box-shadow: 0 7px 18px rgba(37, 59, 128, 0.18);
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.connect-btn i {
  font-size: 19px;
}
.connect-btn:hover:not(:disabled) {
  background: #344f91;
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(37, 59, 128, 0.23);
}
.connect-btn:active:not(:disabled) {
  transform: translateY(0);
}
.connect-btn:disabled {
  background: #cbd5e1;
  box-shadow: none;
  cursor: not-allowed;
}
.call-controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-top: 20px;
}
.icon-btn {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe1ea;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.icon-btn img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.icon-btn:hover {
  background: #f8fafc;
  border-color: #b8c2d2;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.08);
}
.icon-btn.muted {
  background: #fff7ed;
  border-color: #fed7aa;
}
.end-btn {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  color: #ffffff;
  background: #dc2626;
  cursor: pointer;
  box-shadow: 0 7px 16px rgba(220, 38, 38, 0.2);
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.end-btn i {
  font-size: 21px;
  transform: rotate(135deg);
}
.end-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(220, 38, 38, 0.26);
}
.toast {
  position: absolute;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 20;
  min-width: 220px;
  max-width: calc(100% - 40px);
  padding: 12px 18px;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  color: #ffffff;
  background: #1e293b;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.18);
  animation: toastIn 0.25s ease-out;
}
@keyframes toastIn {
  from {
    opacity: 0;
    transform: translate(-50%, 10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
@media (max-width: 900px) {
  .voice-agent {
    padding: 18px;
  }
  .agent-card {
    min-height: auto;
    padding: 24px;
  }
  .agent-method {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .avatar-ring {
    margin-top: 4px;
  }
}
@media (max-width: 600px) {
  .voice-agent {
    padding: 10px;
  }
  .agent-card {
    padding: 18px 14px 22px;
    border-radius: 18px;
  }
  .agent-method {
    padding: 16px;
    margin-bottom: 24px;
    border-radius: 14px;
  }
  .agent-select label {
    font-size: 14px;
  }
  .agent-select select {
    min-height: 46px;
    font-size: 15px;
  }
  .avatar-ring {
    width: 175px;
    height: 175px;
    margin-bottom: 14px;
  }
  .agent-avatar {
    width: 128px;
    height: 128px;
  }
  .pulse {
    width: 148px;
    height: 148px;
  }
  .status-dot {
    right: 13px;
    bottom: 18px;
  }
  .agent-info p {
    font-size: 16px;
  }
  .agent-info span {
    font-size: 13px;
  }
  .ai-body {
    height: 300px;
    padding: 14px;
    border-radius: 14px;
  }
  .transcript-item .transcript-container {
    max-width: 88%;
  }
  .transcript-item .transcript-text {
    padding: 11px 13px;
    font-size: 14px;
    line-height: 1.55;
  }
  .empty-state {
    font-size: 15px;
  }
  .chat-input input {
    height: 48px;
    font-size: 14px;
  }
  .send-btn {
    width: 48px;
    height: 48px;
    flex-basis: 48px;
  }
  .connect-btn {
    height: 52px;
    font-size: 15px;
  }
}
@media (max-width: 380px) {
  .agent-card {
    padding: 14px 10px 18px;
  }
  .agent-method {
    padding: 13px;
  }
  .avatar-ring {
    width: 160px;
    height: 160px;
  }
  .agent-avatar {
    width: 116px;
    height: 116px;
  }
  .pulse {
    width: 136px;
    height: 136px;
  }
  .transcript-item .transcript-container {
    max-width: 92%;
  }
  .call-controls {
    gap: 14px;
  }
}
/*# sourceMappingURL=talk-ai-agent.component.css.map */
